export var SearchMaskGroupType;
(function (SearchMaskGroupType) {
    SearchMaskGroupType["PACKAGE"] = "PACKAGE";
    SearchMaskGroupType["HOTEL"] = "HOTEL";
    SearchMaskGroupType["FLIGHT"] = "FLIGHT";
    SearchMaskGroupType["RAIL"] = "RAIL";
    SearchMaskGroupType["RAIL_PACKAGE"] = "RAIL_PACKAGE";
    SearchMaskGroupType["LAST_MINUTE"] = "LAST_MINUTE";
})(SearchMaskGroupType || (SearchMaskGroupType = {}));
export var SearchMaskInputType;
(function (SearchMaskInputType) {
    SearchMaskInputType["ARRIVAL_AIRPORT"] = "ARRIVAL_AIRPORT";
    SearchMaskInputType["DEPARTURE_AIRPORT"] = "DEPARTURE_AIRPORT";
    SearchMaskInputType["DESTINATION"] = "DESTINATION";
    SearchMaskInputType["DEALS"] = "DEALS";
    SearchMaskInputType["FEATURES"] = "FEATURES";
    SearchMaskInputType["FLIGHT_DEPARTURE_TIME_RANGE"] = "FLIGHT_DEPARTURE_TIME_RANGE";
    SearchMaskInputType["FLIGHT_IGNORE_OPEN_JAW"] = "FLIGHT_IGNORE_OPEN_JAW";
    SearchMaskInputType["PRICE_RANGE"] = "PRICE_RANGE";
    SearchMaskInputType["FLIGHT_RETURN_TIME_RANGE"] = "FLIGHT_RETURN_TIME_RANGE";
    SearchMaskInputType["FLIGHT_STOP_OVER_MAX"] = "FLIGHT_STOP_OVER_MAX";
    SearchMaskInputType["FLEX"] = "FLEX";
    SearchMaskInputType["HOTEL_BOARD_CODES"] = "HOTEL_BOARD_CODES";
    SearchMaskInputType["HOTEL_CATEGORY"] = "HOTEL_CATEGORY";
    SearchMaskInputType["HOTEL_RATING"] = "HOTEL_RATING";
    SearchMaskInputType["HOTEL_RECOMMENDATIONS"] = "HOTEL_RECOMMENDATIONS";
    SearchMaskInputType["HOTEL_ROOM_CODES"] = "HOTEL_ROOM_CODES";
    SearchMaskInputType["OTHER_CODES"] = "OTHER_CODES";
    SearchMaskInputType["LOCATION"] = "LOCATION";
    SearchMaskInputType["PAGINATION"] = "PAGINATION";
    SearchMaskInputType["SPORTS"] = "SPORTS";
    SearchMaskInputType["ACCOMMODATION_TYPE_CODES"] = "ACCOMMODATION_TYPE_CODES";
    SearchMaskInputType["WINTERSPORTS"] = "WINTERSPORTS";
    SearchMaskInputType["WELLNESS"] = "WELLNESS";
    SearchMaskInputType["FAMILY"] = "FAMILY";
    SearchMaskInputType["ROOMCHARACTERISTICS"] = "ROOMCHARACTERISTICS";
    SearchMaskInputType["TARGET_GROUPS"] = "TARGET_GROUPS";
    SearchMaskInputType["TRAIN_TO_FLIGHT"] = "TRAIN_TO_FLIGHT";
    SearchMaskInputType["TRANSFER"] = "TRANSFER";
    SearchMaskInputType["TRAVELLERS"] = "TRAVELLERS";
    SearchMaskInputType["TRAVEL_PERIOD"] = "TRAVEL_PERIOD";
    SearchMaskInputType["TRAVEL_THEMES"] = "TRAVEL_THEMES";
})(SearchMaskInputType || (SearchMaskInputType = {}));
export var AdditionalInputTypes;
(function (AdditionalInputTypes) {
    AdditionalInputTypes["GENERATED_GROUP"] = "GENERATED_GROUP";
})(AdditionalInputTypes || (AdditionalInputTypes = {}));
export var LastMinuteBlockTabType;
(function (LastMinuteBlockTabType) {
    LastMinuteBlockTabType["TODAY"] = "LAST_MINUTE_TODAY";
    LastMinuteBlockTabType["TOMORROW"] = "LAST_MINUTE_TOMORROW";
    LastMinuteBlockTabType["DAYAFTERTOMORROW"] = "LAST_MINUTE_DAYAFTERTOMORROW";
})(LastMinuteBlockTabType || (LastMinuteBlockTabType = {}));
export var DestinationType;
(function (DestinationType) {
    DestinationType["DESTINATION"] = "DESTINATION";
    DestinationType["HOTEL_LIST"] = "HOTEL_LIST";
})(DestinationType || (DestinationType = {}));
